import React from "react";

const LobbyCard = ({offer, onClick, style, isOwnOffer}) => {
    return <div
        key={offer.offerId}
        className="card lobby-card"
        onClick={onClick}
        style={{...style}}
    >
        {/* left side of card*/}
        <div className="lobby-card-left">
            <div className="lobby-card-title">
                {offer.username ? offer.username : "Anonymous"} / {offer.baseTime}+{offer.increment}
            </div>
            <div className="lobby-card-subtitle">
                Variant: {offer.variant}
            </div>
        </div>

        {/* middle part */}
        {offer.variant === "jumpstart" && (
            <div className="lobby-card-range" style={{marginRight: "-1rem"}}>
                <div className="range-item">
                    <span className="range-left">{offer.lower_eval_limit}</span>
                    <span className="range-separator">—</span>
                    <span className="range-right">{offer.upper_eval_limit}</span>
                </div>
                <div className="range-item">
                    <span className="range-left">{offer.lower_move_limit}</span>
                    <span className="range-separator">—</span>
                    <span className="range-right">{offer.upper_move_limit}</span>
                </div>
            </div>
        )}

        {
            offer.variant === "jumpstart" ?
                <div style={{height: "2rem", marginBottom: "-0.35rem"}}>
                    {offer.isCreatorsHandicap === isOwnOffer ? <img src={"/leader.png"} alt={"A small icon with a crown"} style={{height: "80%"}}/> :
                        <img src={"/challenger.png"} alt={"A small icon of swords"} style={{height: "80%"}}/>}
                </div> :
                <div className="color-indicator">
                    {offer.selectedColor === "random" ? (
                        <>
                            <div className="circle white"></div>
                            <div className="circle black"></div>
                        </>
                    ) : offer.selectedColor === "white" ? (
                        <div className="circle black"></div>
                    ) : (
                        <div className="circle white"></div>
                    )}
                </div>
        }
    </div>
}

export default LobbyCard;
